import {
    Link,
    Separator, Text
} from "@fluentui/react";
import { RootState } from "app/store";
import SimpleCard, { ICardProperties } from "components/controls/SimpleCard";
import { AppLinkTo, appStyles } from "global/Application";
import {
    IBenefit as FAM_IBenefit,
    IPlan as FAM_IPlan
} from "model/FlexibleAttributeModel";
import React from "react";
import { useHistory } from "react-router";

interface IProps extends ICardProperties {
    plan: FAM_IPlan;
    state: RootState;
    contextBenefits?: FAM_IBenefit[];
    onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const PlanCard: React.FC<IProps> = (props) => {
    const history = useHistory();

    const onCallout = () => {
        return <>
            <Text block variant="xLarge" className={appStyles.title}>
                Plan Information
            </Text>
            <Text block variant="mediumPlus" className={appStyles.calloutContent} >
                Funding Type: {props.plan.fundingType?.name}<br />
                GF/NGF Type: {props.plan.grandFathered?.name}<br />
            </Text>
            {props.plan.benefitRefs?.length > 0 &&
                <>
                    <Text block variant="xLarge" className={appStyles.title}>
                    Benefits ({props.plan.benefitRefs.length})
                    </Text>
                    <ul className={appStyles.cardPadding}>
                        {((props?.plan?.benefitRefs?.length ?? 0) > 0) &&
                            props.plan.benefitRefs.map(q => {
                                return (
                                    <li key={q.id}>
                                        <Link onClick={() => history.push(AppLinkTo(props.state, { type: 'benefit', id: q.id }))}>
                                            <Text variant="small" key={q.id}>
                                                {q.name}
                                            </Text>
                                        </Link>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </>
            }
            {props?.plan?.feesAndPremiumsRef?.name &&
                <>
                    <Text block variant="xLarge" className={appStyles.title}>
                        Fees And Premium
                    </Text>
                    <ul className={appStyles.cardPadding}>
                        <li>
                            <Link onClick={() => history.push(AppLinkTo(props.state, { type: 'feesAndPremium', id: props?.plan?.feesAndPremiumsRef?.id! }))}>
                                <Text variant="small">
                                    {props?.plan?.feesAndPremiumsRef?.name}
                                </Text>
                            </Link>
                        </li>
                    </ul>
                </>
            }
        </>
    }

    return (
        <SimpleCard
            {...props}
            key={props.plan.id}
            header={props.header ?? "Plan"}
            description={props.plan.name}
            onCallout={onCallout}
            onClick={props.onClick}
            selected={props.selected}

        />
    )
}

export default PlanCard;